<template>
  <div class="d-flex flex-column min-vh-100 p-0 m-0">
    <ca-smtt-navbar
      v-if="$route.name !== 'Login Screen'"
    />
    <router-view/>
  </div>
  <ca-smtt-footer
    v-if="$route.name !== 'Login Screen'"
  />
  <!-- <ca-smtt-auto-logout 
    v-if="loggedIn"
  /> -->
</template>
<script>
import caSmttFooter from './components/ca-smtt-footer.vue'
import CaSmttNavbar from './components/ca-smtt-navbar.vue'
import { useWindowSize } from 'vue-window-size';
// import CaSmttAutoLogout from './components/ca-smtt-auto-logout.vue';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      windowWidth: null,
      mobileDisplay: false
    }
  },
  computed: {
    ...mapState(['loggedIn'])
  },
  components: { 
    caSmttFooter, 
    CaSmttNavbar, 
    // CaSmttAutoLogout 
  },
  mounted() {
    const {width} = useWindowSize()
    this.windowWidth = width
    this.mobileDisplay = this.windowWidth < 1200
    this.$store.commit('setMobileDisplay', this.mobileDisplay)

    this.$watch(
      () => {
        return [this.windowWidth]
      },
      ([windowWidth]) => {
        if (windowWidth > 991) {
          this.mobileDisplay = false
          this.$store.commit('setMobileDisplay', this.mobileDisplay)
        } else {
          this.mobileDisplay = true
          this.$store.commit('setMobileDisplay', this.mobileDisplay)
        }
      }
    );
  },
}
</script>
<style>
@media (max-width: 1200px) {
  #table-headers {
    display: none;
  }
  #table-body tbody, 
  #table-body tr, 
  #table-body td {
    display: block;
  }
  #table-body td {
    position: relative;
    padding-left: 50%;
  }
  #table-body td:before {
    content: attr(header);
    position: absolute;
    left: 5px;
    font-weight: bold;
  }
  #table-body > tr {
    margin-bottom: 5px;
  }
  #table-body tr td:last-child {
    border-bottom: 1px solid #000;
  }
}
</style>